// Template192: Bangkok - Thonburi (Día 2)
// Idéntico a PageThonburi.jsx de guia-bangkok. borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template192 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content ?? "Día 2: Bangkok tradicional";
	const intro = page?.texts?.[1]?.content;
	const titleOverlay = page?.texts?.[2]?.content ?? "Thonburi";
	const canalesTitle =
		page?.texts?.[3]?.content ?? "Paseo por los canales (Khlongs)";
	const canalesBody = page?.texts?.[4]?.content;
	const watTitle = page?.texts?.[5]?.content ?? "Wat Paknam Phasi Charoen";
	const watBody = page?.texts?.[6]?.content;
	const mercadosText = page?.texts?.[7]?.content;
	const artistTitle =
		page?.texts?.[8]?.content ?? "ARTIST'S HOUSE (BAAN SILAPIN)";
	const artistBody = page?.texts?.[9]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const canales2Image = getImageSrc("canales2");
	const artistImage = getImageSrc("artist-house");
	const stickerUrl = getCanvasImageUrl("sticker");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{
							width: isSmallScreen ? 80 : 100,
							position: "absolute",
							bottom: isSmallScreen ? 60 : -10,
							right: isSmallScreen ? "auto" : 0,
							left: isSmallScreen ? 25 : "auto",
						}}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontSize: 32,
							textAlign: "center",
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				{intro && (
					<Box component="p" sx={p}>
						{intro}
					</Box>
				)}
			</Box>

			<Box data-block-id="text-2" sx={{ padding: "8px 12px", marginBottom: 1, marginTop: -0.5 }}>
				<Box
					sx={{
						backgroundColor: "#FFF3CD",
						border: "3px solid #E8A838",
						borderRadius: "12px",
						padding: "8px 20px",
						fontSize: "13px",
						color: "#333",
						width: "100%",
					}}
				>
					<Box
						component="h4"
						sx={{
							margin: 0,
							marginBottom: 1,
							fontSize: "13px",
							fontWeight: 700,
							display: "flex",
							alignItems: "center",
							gap: 0.75,
							color: "#E8A838",
							textTransform: "uppercase",
						}}
					>
						{canalesTitle}
					</Box>
					{canalesBody}
				</Box>
			</Box>

			<Box data-block-id="text-3">
				<Box
					sx={{
						display: "flex",
						gap: 2,
						padding: "0 12px",
						position: "relative",
					}}
				>
					{canales2Image && (
						<Box
							component="img"
							src={canales2Image}
							alt=""
							sx={{
								width: "40%",
								height: 100,
								objectFit: "cover",
								borderRadius: "12px",
							}}
						/>
					)}
					{sabiasQue.length > 0 && (
						<Box
							sx={{ position: "absolute", top: 0, left: "33%", zIndex: 999 }}
						>
							<SabiasQue
								icono={sabiasQue[0]?.icono ?? "🏠"}
								texto={sabiasQue[0]?.texto ?? ""}
							/>
						</Box>
					)}
					<Box sx={{ width: "60%" }}>
						<Box component="h3" sx={h3}>
							{watTitle}
						</Box>
						{watBody && (
							<Box component="p" sx={p}>
								{watBody}
							</Box>
						)}
					</Box>
				</Box>

				{mercadosText && (
					<Box
						data-block-id="text-4"
						sx={{
							display: "flex",
							gap: 2,
							padding: "0 12px",
							marginTop: 1.75,
							position: "relative",
						}}
					>
						<Box sx={{ width: "100%" }}>
							<Box
								sx={{
									backgroundColor: "#FFF3CD",
									padding: 1.5,
									borderRadius: "12px",
								}}
							>
								<Box component="p" sx={p}>
									{mercadosText}
								</Box>
							</Box>
						</Box>
					</Box>
				)}

				<Box
					data-block-id="text-5"
					sx={{
						display: "flex",
						gap: 2,
						padding: "0 12px",
						position: "relative",
						marginTop: 1.75,
						marginBottom: isSmallScreen ? 2.5 : 0,
					}}
				>
					{artistImage && (
						<Box
							component="img"
							src={artistImage}
							alt=""
							sx={{
								width: "40%",
								height: 100,
								objectFit: "cover",
								borderRadius: "12px",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						<Box component="h3" sx={h3}>
							{artistTitle}
						</Box>
						{artistBody && (
							<Box component="p" sx={p}>
								{artistBody}
							</Box>
						)}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template192.thumbnail = "/images/template-1.png";
export default Template192;
